// extracted by mini-css-extract-plugin
module.exports = {"modal":"ModalAlert_modal___w8qb","title":"ModalAlert_title__9TLgu","description":"ModalAlert_description__xbztj"};